/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { type ElementType, type ReactNode, useState, useEffect } from "react";
import { createPortal } from "react-dom";

type CanvaPortalProps = {
  component: ElementType;
  props?: Record<string, unknown>;
  children?: ReactNode;
};

export default function CanvaPortal({
  component: Component,
  props: componentProps = {},
  children
}: CanvaPortalProps) {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = document.createElement("div");
    document.body.appendChild(el);
    setContainer(el);

    return () => {
      document.body.removeChild(el);
    };
  }, []);

  return (
    <>
      {children}
      {container && createPortal(<Component {...componentProps} />, container)}
    </>
  );
}
